import { Link } from "react-router-dom";
import { AppContext } from "../../AppContext";
import { useContext, useState } from "react";
import HTMLReactParser from "html-react-parser";

const NewPapper = () => {
  const { users } = useContext(AppContext);
  const [activeCategory, setActiveCategory] = useState("न्यूज़");
  const { sendClickStatus } = useContext(AppContext);

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [newsletterMsg, setNewsletterMsg] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const truncate = (str, n) => (str.length > n ? str.slice(0, n) + "..." : str);

  const handleNewsletterSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setNewsletterMsg("");

    try {
      const res = await fetch(
        "https://hondaapi.clientcoding.com/api/newsletter",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ name, email }),
        }
      );

      if (res.ok) {
        setNewsletterMsg("✅ Subscribed successfully!");
        setName("");
        setEmail("");
      } else {
        const errorData = await res.json();
        setNewsletterMsg("❌ " + (errorData?.message || "Subscription failed"));
      }
    } catch (err) {
      console.error("Error submitting form:", err);
      setNewsletterMsg("❌ Unexpected error occurred.");
    } finally {
      setSubmitting(false);
    }
  };

  // --- Filter posts with full logic (like CatSports)
  const filteredPosts = users
    .filter(
      (user) =>
        (user.post_type === "post" && user.category_name === activeCategory) ||
        (user.post_type === "New" && user.cat === activeCategory)
    )
    .filter((post) => {
      if (post.post_type === "post") {
        return users.some(
          (img) => img.post_type === "attachment" && img.post_parent === post.ID
        );
      } else {
        return true;
      }
    })
    .map((post) => {
      let imageUrl = "";

      if (post.post_type === "post") {
        const image = users.find(
          (img) => img.post_type === "attachment" && img.post_parent === post.ID
        );
        imageUrl = image ? image.guid : "";
      } else if (post.post_type === "New") {
        imageUrl = "https://hondaapi.clientcoding.com/" + post.guid;
      }

      return {
        id: post.ID,
        title: post.post_title,
        content: post.post_content,
        image: imageUrl,
        author: post.post_type === "New" ? post.author : post.author_name,
        category: post.post_type === "New" ? post.cat : post.category_name,
        post_date_gmt: post.post_date_gmt,
      };
    });

  let publicUrl = process.env.PUBLIC_URL + "/";
  let imagealt = "image";
  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    return date.toLocaleString("en-IN", {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    });
  };
  return (
    <div className="newsletter-area bg-black pd-top-80 pd-bottom-50">
      <div className="container">
        <div className="row">
          <div className="col-xl-9 col-lg-8">
            <div className="row">
              {filteredPosts.length > 0 ? (
                filteredPosts.slice(0, 8).map((post) => (
                  <div className="col-xl-6 col-lg-12" key={post.id}>
                    <div className="single-post-list-wrap style-two style-white text-left">
                      <div className="media">
                        <div className="media-left">
                          <img
                            src={post.image}
                            alt={post.title}
                            style={{
                              maxWidth: "300px",
                              objectFit: "cover",
                              height: "200px",
                            }}
                          />
                        </div>
                        <div className="media-body align-self-center">
                          <div className="details">
                            <div className="post-meta-single">
                              <ul>
                                <li>
                                  <Link
                                    to={`/category/${post.category}`}
                                    className="tag-base tag-blue"
                                    onClick={() => {
                                      sendClickStatus(post.id, "click");
                                    }}
                                  >
                                    {post.category}
                                  </Link>
                                </li>
                                <li>
                                  <i className="fa fa-clock-o" />{" "}
                                  {formatDate(post.post_date_gmt)}
                                </li>
                              </ul>
                            </div>
                            <Link
                              to={`/news-details/${post.id}`}
                              onClick={() => {
                                sendClickStatus(post.id, "click");
                              }}
                            >
                              <h6 className="title mt-2">
                                {truncate(post.title, 50)}
                              </h6>
                            </Link>
                            <Link
                              to={`/news-details/${post.id}`}
                              onClick={() => {
                                sendClickStatus(post.id, "click");
                              }}
                            >
                              {/* <p>
                                {HTMLReactParser(
                                  post.content?.substring(0, 80)
                                )}
                              </p> */}
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <div className="col-12 text-center py-5">
                  <p>No posts found in "{activeCategory}"</p>
                </div>
              )}
            </div>
          </div>

          {/* Newsletter Form */}
          <div className="col-xl-3 col-lg-4">
            <form
              className="single-newsletter-inner bg-blue text-center"
              onSubmit={handleNewsletterSubmit}
            >
              <h5>Newsletter</h5>
              <p>Your daily dose of news — subscribe now</p>

              <div className="single-input-inner mb-2">
                <input
                  type="text"
                  placeholder="Enter Your Name"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  required
                />
              </div>

              <div className="single-input-inner mb-3">
                <input
                  type="email"
                  placeholder="Enter Your Email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>

              <button
                type="submit"
                className="btn btn-white w-100"
                disabled={submitting}
              >
                {submitting ? "Submitting..." : "Subscribe Now"}
              </button>

              {newsletterMsg && (
                <p className="mt-3 text-white">{newsletterMsg}</p>
              )}
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewPapper;
